import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@cloudscape-design/global-styles/index.css';
import { applyMode, Mode } from '@cloudscape-design/global-styles';

// Apply user's preferred visual mode (default: Light)
const savedMode = localStorage.getItem('bmr-visual-mode');
applyMode(savedMode === 'dark' ? Mode.Dark : Mode.Light);

// Initialize Amplify auth (dynamic import avoids module-level Amplify.configure crash in local dev)
import('./apis/midwayAuth').then(({ initAuth }) => initAuth());

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
